import React from 'react';
import styled from 'styled-components';
import {convertToRoman} from 'app/helpers/convertToRoman';
import {COLORS, SIZES, ELEVATIONS, Typography, Image} from '@fupa/fupa-uikit';
import {Emblem} from 'app/components/icons';

const Container = styled.div`
  display: flex;
  padding: ${SIZES['16']};
  margin-bottom: ${SIZES['8']};
  background-color: ${COLORS.white};
  box-shadow: ${ELEVATIONS.Card};
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

const Season = styled(Section)`
  padding-right: ${SIZES['16']};
`;

const TeamContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
`;

const Team = styled(Section)`
  align-items: center;
`;

const ImageContainer = styled.div`
  height: ${SIZES['32']};
  margin-bottom: ${SIZES['8']};
`;

const StyledTypography = styled(Typography)`
  &&& {
    line-height: ${props => props.lineHeight};
  }
`;

const SeasonRow = ({season}) => {
  const getName = team => (team.level > 1 ? team.name.middle + ' ' + convertToRoman(team.level) : team.name.middle);
  const placeholderIcon = <Emblem style={{color: COLORS.lightGrey, fontSize: 32}} />;
  const showImage = team => <Image entity='emblem' src={team.image} width={32} height={32} fit={true} />;

  return (
    <Container>
      <Season>
        <StyledTypography variant='headline2' lineHeight={SIZES['36']}>
          {season.season.name}
        </StyledTypography>
      </Season>
      <TeamContainer>
        <Team>
          <ImageContainer>{season.champion ? showImage(season.champion) : placeholderIcon}</ImageContainer>
          <StyledTypography variant='body1' lineHeight={SIZES['20']}>
            {season.champion ? getName(season.champion) : '-'}
          </StyledTypography>
          <StyledTypography variant='caption1' lineHeight={SIZES['16']}>
            1. Platz
          </StyledTypography>
        </Team>
        <Team>
          <ImageContainer>{season.viceChampion ? showImage(season.viceChampion) : placeholderIcon}</ImageContainer>
          <StyledTypography variant='body1' lineHeight={SIZES['20']}>
            {season.viceChampion ? getName(season.viceChampion) : '-'}
          </StyledTypography>
          <StyledTypography variant='caption1' lineHeight={SIZES['16']}>
            2. Platz
          </StyledTypography>
        </Team>
      </TeamContainer>
    </Container>
  );
};

export default SeasonRow;
